var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"social-media-link",attrs:{"href":_vm.socialMedia.link}},[_c('img',{staticClass:"social-media-link__icon",attrs:{"src":_vm.socialMediaIcon}})])}
var staticRenderFns = []

export { render, staticRenderFns }